// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import {
  AddCashModal,
  AddPortfolioModal,
  generateAddCashRoute,
} from '@advisor-app/components';
import { IconButton, SectionContainer } from '@shared/ui-kit/components';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';
import { type FC, useMemo } from 'react';
import { useHandlerMyIdeasTable } from '../hooks';
import { SavedPortfoliosTable } from './saved-portfolios-table';

export const SavedPortfolios: FC = () => {
  const {
    portfolioName,
    dataIdeasTable,
    dataPortfolio,
    openModalCash,
    handleCloseModalCash,
    loadIdeaOnRedux,
    handleDeleteIdea,
    onOpenPortfolioModal,
    openModalPortfolio,
    onClosePortfolioModal,
    workflow,
    editPortfolioConfig,
    handleEditPortfolio,
    isEditPortfolio,
  } = useHandlerMyIdeasTable();

  const addCashRoute = useMemo(() => generateAddCashRoute(workflow), [workflow]);

  return (
    <SectionContainer
      title={<Translation i18nKey="research.saved-portfolios" ns="research" />}
      popupName="my-research.savedPortfolios"
      tooltip
      actions={
        <IconButton icon="Plus" variant="button" onClick={onOpenPortfolioModal} />
      }
    >
      <AddCashModal
        dataPortfolio={dataPortfolio}
        handleClose={handleCloseModalCash}
        openModal={openModalCash}
        to={addCashRoute}
        portfolioName={portfolioName}
      />
      <AddPortfolioModal
        open={openModalPortfolio}
        onClose={onClosePortfolioModal}
        editPortfolioConfig={editPortfolioConfig}
        isEdit={isEditPortfolio}
      />
      <SavedPortfoliosTable
        data={dataIdeasTable}
        onDeleteIdea={handleDeleteIdea}
        onLoad={loadIdeaOnRedux}
        onEdit={handleEditPortfolio}
      />
    </SectionContainer>
  );
};
